import { Message } from '@mairistem/composants';
import _ from 'lodash';

import type { DepassementTitreType } from '@/types';
import { formatMonetaire } from '@/utils';

interface MessageDepassementTitresProps {
  /** Dépassements calculés par `verifierEligibiliteTitres` : rien n'est rendu s'il n'y en a pas. */
  depassements: DepassementTitreType[];
}

/**
 * Bandeau d'une saisie de titres de paiement (CESU, chèque vacances) supérieure au total des
 * produits qui les acceptent (REG-861 / REG-862). La modale qui l'affiche bloque la validation.
 */
const MessageDepassementTitres = ({ depassements }: MessageDepassementTitresProps) =>
  _.isEmpty(depassements) ? null : (
    <Message warning size="small" data-testid="message-depassement-titres">
      <Message.Header>Règlement supérieur aux produits éligibles</Message.Header>
      <Message.List>
        {_.map(depassements, ({ libelle, montant, plafond }) => (
          <Message.Item key={libelle}>
            {`Le montant réglé en ${libelle} (${formatMonetaire(montant, 2, true)}) dépasse le total des produits éligibles (${formatMonetaire(plafond, 2, true)}).`}
          </Message.Item>
        ))}
      </Message.List>
    </Message>
  );

export default MessageDepassementTitres;
